import { render, staticRenderFns } from "./BlocksAndAlertsEmptyScreen.vue?vue&type=template&id=3a6ee8a6&scoped=true&"
import script from "./BlocksAndAlertsEmptyScreen.vue?vue&type=script&lang=js&"
export * from "./BlocksAndAlertsEmptyScreen.vue?vue&type=script&lang=js&"
import style0 from "./BlocksAndAlertsEmptyScreen.vue?vue&type=style&index=0&id=3a6ee8a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6ee8a6",
  null
  
)

export default component.exports